// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productBrandStyles } from "@ces/Overrides/Components/ProductBrand";
import { color } from "@ces/XDL/Utilities";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { TypographyProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

const nameText: TypographyProps = {
    css: css`
        width: 100%;
        ${wrapInContainerStyles}
        &&& {
            color: ${color("common.ui5")};
        }
    `,
    size: "12px",
    lineHeight: "15px",
    weight: "normal",
    color: "common.ui5",
};

productBrandStyles.nameText = nameText;

productBrandStyles.nameLink = {
    typographyProps: nameText,
};
